export const STATUS_TYPES = [
  'Active',
  'Archived',
  'Closed',
  'Ineligible',
  'TemporaryViolation',
  'Passed',
  'Paused',
  'reset',
  'Transfer',
  'Transferred',
  'Violation',
];
export const accountTypeOptions = [
  '50K Buying Power',
  '100K Buying Power',
  '150K Buying Power',
] as const;
export const accountStageOptions = [
  'evaluation',
  'express-funded',
  'live-funded',
  'practice',
] as const;
